import React from "react";

export const AppLayout = React.lazy(() =>
  import("../components/layouts/AppLayout")
);
export const HomeScreen = React.lazy(() => import("../components/HomeScreen"));
export const SiteDown = React.lazy(() => import("../components/SiteDown"));

export const SelectType = React.lazy(() => import("../components/SelectType"));
export const HomePage = React.lazy(() => import("../pages/Home/index"));
export const Orders = React.lazy(() => import("../pages/Orders/index"));
export const Assistance = React.lazy(() => import("../pages/Assistance/index"));

export const MenuDetailed = React.lazy(() =>
  import("../components/Menu/MenuDetailed")
);
export const Search = React.lazy(() =>
  import("../components/SearchScreen/index")
);

export const Filter = React.lazy(() =>
  import("../components/FilterScreen/index")
);
export const MenuDetailEdit = React.lazy(() =>
  import("../components/Menu/MenuDetailEdit")
);

export const ChargeToRoom = React.lazy(() =>
  import("../pages/ChargeToRoom/index")
);

export const FaceRecog = React.lazy(() => import("../pages/FaceRecog/index"));

export const Payment = React.lazy(() => import("../components/Payment"));
export const ApplePay = React.lazy(() => import("../components/ApplePay"));
export const SamsungPay = React.lazy(() => import("../components/SamsungPay"));
// Profile Components
export const OrderHistory = React.lazy(() =>
  import("../pages/Profile/OrderHistory")
);
export const ManageUsers = React.lazy(() =>
  import("../pages/Profile/ManageUsers")
);

export const ProfileView = React.lazy(() =>
  import("../pages/Profile/ProfileView")
);
export const Register = React.lazy(() => import("../pages/Profile/Register"));
export const EmailVerify = React.lazy(() =>
  import("../pages/Profile/EmailVerify")
);

export const Login = React.lazy(() => import("../pages/Profile/Login"));
export const ResetPassword = React.lazy(() =>
  import("../pages/Profile/ResetPassword")
);
export const ForgotPassword = React.lazy(() =>
  import("../pages/Profile/ForgotPassword")
);
export const PostPaymentProcess = React.lazy(() =>
  import("../components/PostPaymentProcess")
);
